import { Dialog, Transition } from '@headlessui/react'
import { Fragment, useRef } from 'react'

import { Button } from '@ui/components/core'
import { Spinner } from '@ui/components/loaders'

interface DeleteModalProps {
  open: boolean
  handleAction: () => void
  actionIdentifier: string
  dismissAction: () => void
  dismissIdentifier: string
  title: string
  message: string
  loading?: boolean
}

export function ActionModal({
  open,
  title,
  message,
  handleAction,
  actionIdentifier,
  dismissAction,
  dismissIdentifier,
  loading,
}: DeleteModalProps) {
  const cancelButtonRef = useRef(null)

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        data-testid="action-modal"
        className="relative z-50"
        initialFocus={cancelButtonRef}
        onClose={() => {}}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div className="fixed inset-0 bg-gray-500/75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
              <Dialog.Panel className="relative overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                {loading ? (
                  <Spinner />
                ) : (
                  <>
                    <div className="mt-5 w-full justify-start sm:mt-4 sm:flex">
                      <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                        <Dialog.Title as="h3" className="break-all text-base font-semibold leading-6 text-gray-900">
                          {title}
                        </Dialog.Title>
                        <div className="mt-2">
                          <p className="text-sm text-gray-500">{message}</p>
                        </div>
                      </div>
                    </div>
                    {/* <div className="w-full">
                      <Notification
                        show={notification !== null}
                        type={NotificationTypeEnum.ERROR}
                        title={notification?.title || ''}
                        message={notification?.message}
                        richMessage={notification?.richMessage}
                        messageList={notification?.messageList}
                      />
                    </div> */}
                    <div className="mt-5 w-full justify-end sm:mt-4 sm:flex">
                      <Button onClick={handleAction} disabled={loading} loading={loading} variant="primary">
                        {actionIdentifier}
                      </Button>
                      <Button variant="secondary" onClick={() => dismissAction()} disabled={loading}>
                        {dismissIdentifier || 'Cancel'}
                      </Button>
                    </div>
                  </>
                )}
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
